module.exports = __webpack_public_path__ + "static/media/flexed-bicep.5c11c047.svg";